
<ng-template #contentModalFotos let-modal>
    <div class="modal-header d-flex justify-content-between align-items-center">
        <h2>Fotos da consulta</h2>
        <button (click)="modal.close('close')" class="btn btn-xs btn-danger rounded-circle btn-icon">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body scroll-auto p-2">
        <div class="row p-1">
            <ng-container *ngFor="let img of fotos">
                <div *ngIf="!img.remover" class="col-sm-6 col-md-4 col-lg-2 p-1">
                    <div class="bg-light card position-relative">
                        <div class="position-absolute d-flex justify-content-end w-100 p-1">
                            <button (click)="remover(img)" class="btn btn-sm btn-danger btn-icon rounded-circle"><i
                                    class="mdi mdi-delete"></i></button>
                        </div>
                        <div class="img-container">
                            <img [src]="img.url || img.base64" alt="">
                        </div>
                        <div class="p-1"><input [(ngModel)]="img.nome" type="text" class="form-control text-center"></div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngFor="let img of fotosNovas">
                    <div *ngIf="!img.remover" class="col-sm-6 col-md-4 col-lg-2 p-2">
                        <div class="bg-light card position-relative">
                            <div class="position-absolute d-flex justify-content-end w-100 p-1">
                                <button (click)="remover(img)" class="btn btn-sm btn-danger btn-icon rounded-circle"><i
                                        class="mdi mdi-delete"></i></button>
                            </div>
                            <div class="img-container">
                                <img [src]="img.url || img.base64" alt="">
                            </div>
                            <div class="p-1"><input [(ngModel)]="img.nome" type="text" class="form-control text-center"></div>
                        </div>
                    </div>
                </ng-container>
        </div>
    </div>
    <div class="modal-footer">
        <div class="w-100">
            <textarea [style.maxHeight.px]="100" [(ngModel)]="observacoes" placeholder="Observações" name="obs" id="obs" cols="4"
                class="form-control"></textarea>
        </div>
    </div>
    <div class="modal-footer justify-content-between">
        <button (click)="getImages()" class="btn-lg btn btn-info btn-icon">
            <span>
                Adicionar imagens
            </span>
            <i class="mdi mdi-image-plus"></i>
        </button>
        <button (click)="modal.close('ok')" class="btn btn-success btn-lg px-5">Salvar Alterações</button>
    </div>
</ng-template>